import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

// Common for BS journey
import {
  LMT_ENHCMT_getBanks_API_CALL,
  LMT_ENHCMT_getBanks_API_CALL_extrareducer,
} from './limit-enhancement/api/get-bank';
import {
  LMT_ENHCMT_getPrefferedOptions_API_CALL,
  LMT_ENHCMT_getPrefferedOptions_API_CALL_extrareducer,
} from './limit-enhancement/api/get-preffered-option';

// Online BS Journey
import {
  LMT_ENHCMT_bsOnlineTxn_API_CALL,
  LMT_ENHCMT_bsOnlineTxn_API_CALL_extrareducer,
} from './limit-enhancement/api/bs-online-txn';
import {
  LMT_ENHCMT_bsVerifyTxn_API_CALL,
  LMT_ENHCMT_bsVerifyTxn_API_CALL_extrareducer,
} from './limit-enhancement/api/bs-verify-txn';
import {
  LMT_ENHCMT_perfiosOnlineBanking_API_CALL,
  LMT_ENHCMT_perfiosOnlineBanking_API_CALL_extrareducer,
} from './limit-enhancement/api/perfios-online-banking';

// Offline BS Journey
import {
  LMT_ENHCMT_s3FileUpload_API_CALL,
  LMT_ENHCMT_s3FileUpload_API_CALL_extrareducer,
} from './limit-enhancement/api/s3-file-upload';
import {
  LMT_ENHCMT_saveBsDocUpload_API_CALL,
  LMT_ENHCMT_saveBsDocUpload_API_CALL_extrareducer,
} from './limit-enhancement/api/save-bs-docupload';

import { LMT_ENHCMT_updateCurrentScreenReducer } from './limit-enhancement/functions/update-current-screen';
import { LMT_ENHCMT_updatePreviousScreenReducer } from './limit-enhancement/functions/update-previous-screen';
import { LMT_ENHCMT_selectTheBankReducer } from './limit-enhancement/functions/select-the-bank';
import { LMT_ENHCMT_moveBackConvUIReducer } from './limit-enhancement/functions/move-back-conv-ui';
import { LMT_ENHCMT_setNoOfStatementReducer } from './limit-enhancement/functions/set-no-of-statement';
import { LMT_ENHCMT_setBankStatementPasswordReducer } from './limit-enhancement/functions/set-bank-statement-password';
import { LMT_ENHCMT_flushUploadResponsesReducer } from './limit-enhancement/functions/flush-upload-responses';
import { LMT_ENHCMT_flushAPICallsDataReducer } from './limit-enhancement/functions/flush-api-calls-data';
import { LMT_ENHCMT_updateAckScreenMsgsReducer } from './limit-enhancement/functions/update-ack-screen-msgs';

import initialStateLimitEnhancement from './limit-enhancement/api/intial-state-bs-journey';
import { LMT_ENHCMT_comingBackFromPerfiosReducer } from './limit-enhancement/functions/coming-back-from-perfios';
import { LMT_ENHCMT_setGlobalOverlayLoaderReducer } from './limit-enhancement/functions/set-global-overlay-loader';
import {
  LMT_ENHCMT_updateMonthlyStatementErrReducer,
  LMT_ENHCMT_uploadMonthlyStatementErrReducer,
} from './limit-enhancement/functions/update-monthly-stmt-err';
import { LMT_ENHCMT_updateJourneyTypeEnumReducer } from './limit-enhancement/functions/update-journey-type-enum';

export const limitEnhancementSlice = createSlice({
  name: 'limitEnhancementJourney',
  initialState: initialStateLimitEnhancement,
  reducers: {
    ...LMT_ENHCMT_setNoOfStatementReducer,
    ...LMT_ENHCMT_updateCurrentScreenReducer,
    ...LMT_ENHCMT_selectTheBankReducer,
    ...LMT_ENHCMT_updatePreviousScreenReducer,
    ...LMT_ENHCMT_moveBackConvUIReducer,
    ...LMT_ENHCMT_setBankStatementPasswordReducer,
    ...LMT_ENHCMT_flushUploadResponsesReducer,
    ...LMT_ENHCMT_flushAPICallsDataReducer,
    ...LMT_ENHCMT_updateAckScreenMsgsReducer,
    ...LMT_ENHCMT_comingBackFromPerfiosReducer,
    ...LMT_ENHCMT_setGlobalOverlayLoaderReducer,
    ...LMT_ENHCMT_updateMonthlyStatementErrReducer,
    ...LMT_ENHCMT_updateJourneyTypeEnumReducer,
  },
  extraReducers: {
    ...LMT_ENHCMT_getBanks_API_CALL_extrareducer,
    ...LMT_ENHCMT_getPrefferedOptions_API_CALL_extrareducer,
    ...LMT_ENHCMT_bsOnlineTxn_API_CALL_extrareducer,
    ...LMT_ENHCMT_bsVerifyTxn_API_CALL_extrareducer,
    ...LMT_ENHCMT_s3FileUpload_API_CALL_extrareducer,
    ...LMT_ENHCMT_saveBsDocUpload_API_CALL_extrareducer,
    ...LMT_ENHCMT_perfiosOnlineBanking_API_CALL_extrareducer,
  },
});

export const {
  LMT_ENHCMT_updateCurrentScreen,
  LMT_ENHCMT_selectTheBank,
  LMT_ENHCMT_updatePreviousScreen,
  LMT_ENHCMT_moveBackConvUI,
  LMT_ENHCMT_setNoOfStatement,
  LMT_ENHCMT_setBankStatementPassword,
  LMT_ENHCMT_flushUploadResponses,
  LMT_ENHCMT_flushAPICallsData,
  LMT_ENHCMT_updateAckScreenMsgs,
  LMT_ENHCMT_comingBackFromPerfios,
  LMT_ENHCMT_setGlobalOverlayLoader,
  LMT_ENHCMT_updateMonthlyStatementErr,
  LMT_ENHCMT_updateJourneyTypeEnum,
} = limitEnhancementSlice.actions;

export function useLimitEnhancementStore() {
  const bankStatementState = useSelector(
    (state) => state.limitEnhancementJourney
  );
  const previousScreen = useSelector(
    (state) => state.limitEnhancementJourney.previousScreen
  );
  const currentScreen = useSelector(
    (state) => state.limitEnhancementJourney.currentScreen
  );
  const nextScreen = useSelector(
    (state) => state.limitEnhancementJourney.nextScreen
  );
  const getBankApiInfo = useSelector(
    (state) => state.limitEnhancementJourney.getBankAPICall
  );
  const dispatch = useDispatch();
  return {
    // TODO: State returns here
    bankStatementState,
    previousScreen,
    nextScreen,
    currentScreen,
    getBankApiInfo,

    // TODO: Write the sync action functions here
    updateScreen: () => dispatch(LMT_ENHCMT_updateCurrentScreen()),
    selectTheBank: (bankObj) => dispatch(LMT_ENHCMT_selectTheBank(bankObj)),
    updateCurrentScreen: (screenName) =>
      dispatch(LMT_ENHCMT_updateCurrentScreen(screenName)),
    updatePreviousScreen: (screenName) =>
      dispatch(LMT_ENHCMT_updatePreviousScreen(screenName)),
    moveBackConvUI: (screenName) =>
      dispatch(LMT_ENHCMT_moveBackConvUI(screenName)),
    setNoOfStatement: (noOfStatement) =>
      dispatch(LMT_ENHCMT_setNoOfStatement(noOfStatement)),
    setBankStatementPassword: (password) =>
      dispatch(LMT_ENHCMT_setBankStatementPassword(password)),
    flushUploadResponses: (password) =>
      dispatch(LMT_ENHCMT_flushUploadResponses(password)),

    // TODO: API calls or Async stuff here
    getBanks_API_CALL: (payload) =>
      dispatch(LMT_ENHCMT_getBanks_API_CALL(payload)),
    getPrefferedOptions_API_CALL: (payload) =>
      dispatch(LMT_ENHCMT_getPrefferedOptions_API_CALL(payload)),

    perfiosOnlineBanking_API_CALL: (payload) =>
      dispatch(LMT_ENHCMT_perfiosOnlineBanking_API_CALL(payload)),
    bsOnlineTxn_API_CALL: (payload) =>
      dispatch(LMT_ENHCMT_bsOnlineTxn_API_CALL(payload)),
    bsVerifyTxn_API_CALL: (payload) =>
      dispatch(LMT_ENHCMT_bsVerifyTxn_API_CALL(payload)),
    s3FileUpload_API_CALL: (payload) =>
      dispatch(LMT_ENHCMT_s3FileUpload_API_CALL(payload)),
    saveBsDocUpload_API_CALL: (payload) =>
      dispatch(LMT_ENHCMT_saveBsDocUpload_API_CALL(payload)),
    flushAPICallsData: () => dispatch(LMT_ENHCMT_flushAPICallsData()),
    updateAckScreenMsgs: (payload) =>
      dispatch(LMT_ENHCMT_updateAckScreenMsgs(payload)),
    comingBackFromPerfios: (payload) =>
      dispatch(LMT_ENHCMT_comingBackFromPerfios(payload)),
    setGlobalOverlayLoader: (payload) =>
      dispatch(LMT_ENHCMT_setGlobalOverlayLoader(payload)),
    updateMonthlyStatementErr: (payload) =>
      dispatch(LMT_ENHCMT_updateMonthlyStatementErr(payload)),
    updateJourneyTypeEnum: (payload) =>
      dispatch(LMT_ENHCMT_updateJourneyTypeEnum(payload)),
  };
}

export default limitEnhancementSlice.reducer;
